import _ from 'lodash';

export const preparingShowingFactsForCma = (questions) => {
    questions = _.orderBy(questions, 'factId');
    let questionsToCopy = new Set([]);
    let lastFactId = -1;
    for (let i = 0; i < questions.length; i++) {
        if (questions[i].factId !== lastFactId) {
            lastFactId = questions[i].factId;
            questionsToCopy.add({ indx: i, Q: questions[i] });
        }
    }
    questionsToCopy = Array.from(questionsToCopy);

    for (let i = 0; i < questionsToCopy.length; i++)
        questions.splice(questionsToCopy[i].indx + i, 0, { ...questionsToCopy[i].Q, showFactOnly: true, questionId: questionsToCopy[i].Q.questionId + 1000, qFactIndex: i });

    let currentFactIndex;
    for (let i = 0; i < questions.length; i++) {
        if (questions[i]?.showFactOnly) currentFactIndex = i;
        else {
            questions[i]['qAterFactIndex'] = i - currentFactIndex;
        }
    }

    return questions;
};